import { render, staticRenderFns } from "./PermissionsModalForm.vue?vue&type=template&id=1f7b90e6&"
import script from "./PermissionsModalForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports